export const GADS_ID = "AW-10838308402";
export const GA4_ID = "G-XGX4E0JSWW";
// Conversion label from the Google Ads "Thanks Page" event snippet: send_to: 'AW-10838308402/<LABEL>'
export const GADS_THANKS_LABEL = "k1eYCO61hIsZELLsjbAo";

// GA4 auto page_view is disabled in index.html; this fires exactly one page_view per route (incl. first load).
export const trackPageView = (path) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", { send_to: GA4_ID, page_path: path, page_location: window.location.href, page_title: document.title });
};

export const trackLeadConversion = (leadType) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function" || !GADS_THANKS_LABEL) return;
  window.gtag("event", "conversion", {
    send_to: `${GADS_ID}/${GADS_THANKS_LABEL}`,
    value: 1.0,
    currency: "AUD",
    lead_type: leadType,
  });
};

export const CONVERTED = (leadType) => ({ state: { converted: true, leadType } });
